import { Buffer } from "buffer";

import * as Consts from "./consts.js";

import { PoweredUP } from "./poweredup-browser.js";
import { Color } from "./color.js";

import { BaseHub } from "./hubs/basehub.js";
import { DuploTrainBase } from "./hubs/duplotrainbase.js";
import { Hub } from "./hubs/hub.js";
import { Mario } from "./hubs/mario.js";
import { MoveHub } from "./hubs/movehub.js";
import { RemoteControl } from "./hubs/remotecontrol.js";
import { TechnicMediumHub } from "./hubs/technicmediumhub.js";
import { WeDo2SmartHub } from "./hubs/wedo2smarthub.js";

import { ColorDistanceSensor } from "./devices/colordistancesensor.js";
import { CurrentSensor } from "./devices/currentsensor.js";
import { Device } from "./devices/device.js";
import { DuploTrainBaseColorSensor } from "./devices/duplotrainbasecolorsensor.js";
import { DuploTrainBaseMotor } from "./devices/duplotrainbasemotor.js";
import { DuploTrainBaseSpeaker } from "./devices/duplotrainbasespeaker.js";
import { DuploTrainBaseSpeedometer } from "./devices/duplotrainbasespeedometer.js";
import { HubLED } from "./devices/hubled.js";
import { Light } from "./devices/light.js";
import { MediumLinearMotor } from "./devices/mediumlinearmotor.js";
import { MotionSensor } from "./devices/motionsensor.js";
import { MoveHubMediumLinearMotor } from "./devices/movehubmediumlinearmotor.js";
import { MoveHubTiltSensor } from "./devices/movehubtiltsensor.js";
import { PiezoBuzzer } from "./devices/piezobuzzer.js";
import { RemoteControlButton } from "./devices/remotecontrolbutton.js";
import { SimpleMediumLinearMotor } from "./devices/simplemediumlinearmotor.js";
import { TechnicColorSensor } from "./devices/techniccolorsensor.js";
import { TechnicDistanceSensor } from "./devices/technicdistancesensor.js";
import { TechnicForceSensor } from "./devices/technicforcesensor.js";
import { TechnicLargeAngularMotor } from "./devices/techniclargeangularmotor.js";
import { TechnicLargeLinearMotor } from "./devices/techniclargelinearmotor.js";
import { TechnicSmallAngularMotor } from "./devices/technicsmallangularmotor.js";
import { TechnicMediumAngularMotor } from "./devices/technicmediumangularmotor.js";
import { TechnicMediumHubAccelerometerSensor } from "./devices/technicmediumhubaccelerometersensor.js";
import { TechnicMediumHubGyroSensor } from "./devices/technicmediumhubgyrosensor.js";
import { TechnicMediumHubTiltSensor } from "./devices/technicmediumhubtiltsensor.js";
import { TechnicXLargeLinearMotor } from "./devices/technicxlargelinearmotor.js";
import { Technic3x3ColorLightMatrix } from "./devices/technic3x3colorlightmatrix.js";
import { TiltSensor } from "./devices/tiltsensor.js";
import { TrainMotor } from "./devices/trainmotor.js";
import { VoltageSensor } from "./devices/voltagesensor.js";
import { TachoMotor } from "./devices/tachomotor.js";
import { AbsoluteMotor } from "./devices/absolutemotor.js";
import { BasicMotor } from "./devices/basicmotor.js";

import { isWebBluetooth } from "./utils.js";

const globalRef = globalThis as typeof globalThis & { Buffer?: typeof Buffer };
if (!globalRef.Buffer) {
    globalRef.Buffer = Buffer;
}

// @ts-ignore
window.PoweredUP = {
    PoweredUP,
    BaseHub,
    WeDo2SmartHub,
    TechnicMediumHub,
    Hub,
    RemoteControl,
    DuploTrainBase,
    Consts,
    Color,
    ColorDistanceSensor,
    Device,
    DuploTrainBaseColorSensor,
    DuploTrainBaseMotor,
    DuploTrainBaseSpeaker,
    DuploTrainBaseSpeedometer,
    HubLED,
    Light,
    Mario,
    MediumLinearMotor,
    MotionSensor,
    MoveHub,
    MoveHubMediumLinearMotor,
    MoveHubTiltSensor,
    PiezoBuzzer,
    RemoteControlButton,
    SimpleMediumLinearMotor,
    TechnicColorSensor,
    TechnicDistanceSensor,
    TechnicForceSensor,
    TechnicMediumHubAccelerometerSensor,
    TechnicMediumHubGyroSensor,
    TechnicMediumHubTiltSensor,
    TechnicSmallAngularMotor,
    TechnicMediumAngularMotor,
    TechnicLargeAngularMotor,
    TechnicLargeLinearMotor,
    TechnicXLargeLinearMotor,
    Technic3x3ColorLightMatrix,
    TiltSensor,
    TrainMotor,
    VoltageSensor,
    CurrentSensor,
    TachoMotor,
    AbsoluteMotor,
    BasicMotor,
    isWebBluetooth
};
